import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { loader } from 'graphql.macro';
import { useMutation } from 'react-apollo-hooks';
import { useTranslation } from 'react-i18next';

import { Button, Select, Form, Modal, useNotifications } from '@loyalup/ui';

const DELETE_CLIENT_ORDERS_MUTATION = loader('../../gql/mutations/DeleteClientOrders.gql');

const ClientOrderGroupActions = ({ className, selection, loading, onActionFinish, history }) => {
  const [t] = useTranslation();

  const [sendNotification] = useNotifications();

  const { include, exclude, conds, text } = selection;
  const [deletingOrders, setDeletingOrders] = useState(false);

  const [deleteOrders] = useMutation(DELETE_CLIENT_ORDERS_MUTATION, { update: () => onActionFinish('delete') });

  const variables = {
    selection: {
      all: include === 'all',
      include: include === 'all' ? [] : include,
      exclude,
      conds,
      text,
    },
  };

  const items = [
    {
      label: t('Удалить заказы'),
      onClick: () => {
        setDeletingOrders(true);
      },
    },
  ].filter(item => !!item);

  return (
    <div className={className}>
      <Select theme="green" loading={loading} disabled={include.length === 0} label={t('Действия')} items={items} />
      <Modal confirm isOpen={!!deletingOrders} onClose={() => setDeletingOrders(false)}>
        <Form
          onSubmit={() => {
            setDeletingOrders(false);
            try {
              deleteOrders({ variables });
              sendNotification({ text: 'Удалено', type: 'info' });
            } catch (e) {
              sendNotification({ text: 'Произошла ошибка', type: 'error' });
            }
          }}
        >
          <p>{t('Вы уверены что хотите удалить выбранные заказы?')}</p>
          <div>
            <Button type="submit" theme="green" center loading={loading}>
              {t('Удалить')}
            </Button>
            <Button theme="black" onClick={() => setDeletingOrders(false)}>
              {t('Отмена')}
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

ClientOrderGroupActions.propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  onActionFinish: PropTypes.func,
  selection: PropTypes.shape({
    conds: PropTypes.array,
    text: PropTypes.string,
    include: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
    exclude: PropTypes.array.isRequired,
  }),
};

export default withRouter(ClientOrderGroupActions);
